var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"news-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"news-time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"foo",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }